import PropTypes from 'prop-types'
import React from 'react'
import BoldLabelAndContent from '../../molecules/BoldLabelAndContent'
import TrackingGeneralSteps from './TrackingGeneralSteps'

const TrackingGeneralInfo = ({
  code,
  generalDetail = [],
  stepValues = [],
  stepsMessage,
  isEnded,
  stepWithColor = false
}) => {
  return (
    <div className="md:w-72 w-full">
      <div className="flex flex-col border border-neutral-12 md:rounded-xl">
        <div className="bg-blue-350 p-6 md:rounded-t-xl">
          <p className="text-lg">
            Código de solicitud: <span className="font-bold">{code}</span>
          </p>
        </div>
        <div className="p-6 flex flex-col gap-4">
          {generalDetail.map((detail, index) => (
            <BoldLabelAndContent
              el="p"
              key={index}
              label={detail.label}
              content={detail.content}
              className="flex flex-col"
            />
          ))}
        </div>
        <TrackingGeneralSteps stepValues={stepValues} isEnded={isEnded} stepWithColor={stepWithColor} />
      </div>
      {stepsMessage}
    </div>
  )
}
export default TrackingGeneralInfo

TrackingGeneralInfo.propTypes = {
  code: PropTypes.string,
  generalDetail: PropTypes.array,
  stepValues: PropTypes.array,
  stepsMessage: PropTypes.node,
  isEnded: PropTypes.bool,
  stepWithColor: PropTypes.bool
}
